import { render, staticRenderFns } from "./communityBmember.vue?vue&type=template&id=8025b528&scoped=true"
import script from "./communityBmember.vue?vue&type=script&lang=js"
export * from "./communityBmember.vue?vue&type=script&lang=js"
import style0 from "./communityBmember.vue?vue&type=style&index=0&id=8025b528&prod&scoped=true&lang=css"
import style1 from "./communityBmember.vue?vue&type=style&index=1&id=8025b528&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8025b528",
  null
  
)

export default component.exports